<template>
<div>
  <div class="my-4">
    <v-row>
      <v-col cols="4">
        <strong>クラス選択</strong>
        <class-picker
          :classes="classes"
          :model-value="classId"
          @update:modelValue="selectClassName"
        ></class-picker>
      </v-col>
      <v-col cols="4">
        <v-checkbox
          v-model="showQuit"
          color="primary"
          label="退園済み"
        ></v-checkbox>
      </v-col>
    </v-row>
  </div>

  <v-progress-linear v-if="isFetching" indeterminate color="primary" class="my-4" />

  <v-data-table
    class="pt-4"
    :items="childrenWithDevices"
    :headers="childrenTableHeaders"
    hide-default-footer
    :items-per-page="-1"
    item-key="childId"
  >
    <template v-slot:[`item.name`]="{ item }">
      {{ `${item.child.lastName} ${item.child.firstName}` }}
    </template>

    <template v-slot:[`item.class`]="{ item }">
      {{ getClassName(item.child) }}
    </template>

    <template v-slot:[`item.sensors`]="{ item }">
      <v-chip
        closable
        v-for="device in item.devices"
        :key="device.sid"
        @click:close="remove(item.child.childId, device.sid)"
      >
        {{ device.sid }}
      </v-chip>
    </template>


    <template v-slot:[`item.edit`]="{ item }">
      <v-btn
        color="primary"
        variant="flat"
        :id="item.child.childId"
        @click="selectedChild = item.child"
      >
        追加
      </v-btn>
    </template>
  </v-data-table>

  <v-dialog
    :model-value="selectedChild !== null"
    @update:model-value="(val) => { if (!val) selectedChild = null }"
    max-width="720"
  >
    <v-card class="pa-4" v-if="selectedChild">
      <div class="mb-4">
        <h4>{{ selectedChild.lastName }}  {{ selectedChild.firstName }}</h4>
      </div>
      <p class="text-caption">リーダーをパソコンに接続し、読み取るデバイスをリーダーの上に正しく配置した後、下の「読み取り」ボタンを押下してください</p>
      <v-row align="center">
        <v-col cols="3">
          センサーID
        </v-col>
        <v-col cols="6">
          <div
            class="device-result"
          >
            {{ detectedIdm }}
          </div>
        </v-col>
        <v-col cols="3">
          <v-btn
            color="primary"
            variant="flat"
            rounded
            @click="read"
          >
            読み取り
          </v-btn>
        </v-col>
      </v-row>
      <v-progress-linear v-if="isRegistering" indeterminate color="primary" class="my-4" />
      <div class="mt-8">
        <v-btn
          color="primary"
          variant="flat"
          block
          large
          :disabled="!detectedIdm || isRegistering"
          @click="register"
        >
          登録
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</div>
</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue';
import { classModule } from '@/store/dataModules/classModule';
import { pasoriSensorModule } from '@/store/viewModules/pasori/pasoriSensorModule'
import ClassPicker from '@/components/atoms/ClassPicker.vue';
import { NurseryChildResponse, NurseryClassResponse } from 'chaild-api/lib';
import { PasoriDevice } from '@/api/ApiDevice';
import {
  NFCPortLib,
  Configuration,
  DetectionOption,
  array_tohexs
} from '@/lib/NFCPortLib'


interface DataType {
  isFetching: boolean;
  showQuit: boolean;
  classId: number | null;
  selectedChild: NurseryChildResponse | null;
  detectedIdm: string | null;
  isRegistering: boolean;
}

interface ChildWithDevices {
  child: NurseryChildResponse;
  devices: PasoriDevice[];
}

export default defineComponent({
  components: {
    ClassPicker
  },

  data: (): DataType => {
    return {
      isFetching: false,
      showQuit: false,
      classId: null,
      selectedChild: null,
      detectedIdm: null,
      isRegistering: false,
    }
  },

  computed: {
    classes(): NurseryClassResponse[] {
      return classModule.classes
    },
    childrenTableHeaders: function() {
      return [
        { title: '園児氏名', value: 'name', },
        { title: 'クラス名', value: 'class', },
        { title: 'UID', value: 'sensors', },
        { title: '', value: 'edit', },
      ];
    },
    children() {
      if (!this.showQuit) {
        return pasoriSensorModule.children.filter((c) => !c.quitDate)
      }
      return pasoriSensorModule.children
    },
    sensors() {
      return pasoriSensorModule.sensors
    },
    childrenWithDevices(): ChildWithDevices[] {
      return this.children.map((c) => {
        const devices = pasoriSensorModule.sensors.filter((device) => device.childId === c.childId)
        return {
          child: c,
          devices: devices
        }
      })
    }
  },

  methods: {
    getClassName(child: NurseryChildResponse) {
      if (child.nurseryClasses) {
        const latest = child.nurseryClasses.length > 0 ? child.nurseryClasses[0] : null;
        if (latest) {
          return latest.className
        }
      }
      return '-';
    },
    async selectClassName(classId: number) {
      this.isFetching = true;
      this.classId = classId;
      await Promise.all([
        pasoriSensorModule.listChildren({ classId }),
        pasoriSensorModule.listSensors({ classId })
      ])
      this.isFetching = false;
    },
    async read() {
      const lib = new NFCPortLib()
      const nfcConfig = new Configuration(500, 500, true, true);

      try {
        await lib.init(nfcConfig);
        await lib.open();
      } catch {
        alert('読み取りデバイスに接続できませんでした。ドライバーが正しくインストールされていない可能性があります。')
      }
      
      try {
        /* detectCard(FeliCa Card) */
        const detectOption = new DetectionOption(new Uint8Array([0xff, 0xff]), 0, true, false, null);
        const card = await lib.detectCard('iso14443-3A', detectOption)
          .then(ret => {
            return ret;
          }, (error) => {
            // detectTitle.innerText = 'Card is not detected';
            console.log(error)
            // throw (error);
          });

        this.detectedIdm = array_tohexs(card.uid)

      } catch {
        alert('センサーの読み取りに失敗しました。センサーが正しくセットされているか確認してください。')
      }

      /* close() */
      await lib.close();
    },
    async register() {
      if (
        this.selectedChild
        && this.detectedIdm
        && this.classId
      ) {
      this.isRegistering = true;

      await pasoriSensorModule.registerSensor({
        sid: this.detectedIdm,
        childId: this.selectedChild.childId,
        classId: this.classId
      })
      
      this.selectedChild = null;
      this.detectedIdm = null;
      this.isRegistering = false;
      }
    },
    async remove(childId: number, sid: string) {
      if (
        this.classId
      ) {
        this.isFetching = true;
        await pasoriSensorModule.removeSensor({
          childId,
          sid,
          classId: this.classId
        })
        this.isFetching = false
      }
    }
  },
  // async mounted() {

  // }
})
</script>
<style lang="scss" scoped>
.device-result {
  border: solid 1px #e0e0e0;
  border-radius: 4px;
  padding: 8px;

  height: 40px;
}

</style>